export default {"src":"/_next/static/media/idfc-bank.32daa1dc.svg","height":71,"width":200,"blurWidth":0,"blurHeight":0};